var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinceButton',{staticClass:"booking-status",style:(_vm.statusStyle),on:{"click":_vm.toBook}},[_vm._v(" "+_vm._s(_vm.statusTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }